import { render, staticRenderFns } from "./AlertEditDialog.vue?vue&type=template&id=535f0ca5&scoped=true"
import script from "./AlertEditDialog.vue?vue&type=script&lang=ts"
export * from "./AlertEditDialog.vue?vue&type=script&lang=ts"
import style0 from "./AlertEditDialog.vue?vue&type=style&index=0&id=535f0ca5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535f0ca5",
  null
  
)

export default component.exports